import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useIsDesktop } from "@hooks/layout";

import { ChoiceButtons } from "@components/QuestionFlowDialog/components/ChoiceButtons";

import { AccountType, useAccountType } from "@/contexts/AccountTypeContext";

import * as Styled from "../styles";
import { formatButtonsData, THandleNextStepProp } from "../utils";

// Subscribers only answer Part 1 (which lane?); Free/guests also answer Part 2
// (which product?). The counter total tracks the account-type's longest path.
const PART_1 = ["musicUse", "advertisement", "broadcastNetwork", "musicContent", "livestreams"];
const FREE_GUEST_ORDER = [...PART_1, "willingToPay", "giveCredit", "frequency", "trackCount"];

export const ChoiceSection: FC<THandleNextStepProp> = ({ handleLeftChoice, handleRightChoice, type }) => {
  const isDesktop = useIsDesktop();
  const { accountType } = useAccountType();
  const { t } = useTranslation(isDesktop ? "questionFlow" : "questionFlowMobile", { keyPrefix: `basicSteps.${type}` });

  const order = accountType === AccountType.SUBSCRIPTION ? PART_1 : FREE_GUEST_ORDER;
  const questionNum = order.indexOf(type) + 1;
  const totalQuestions = order.length;

  return (
    <Styled.ContentWrapper $isChoiceStep>
      <Styled.StepCounter>
        Question {questionNum} of {totalQuestions}
      </Styled.StepCounter>
      <Styled.Heading style={{ fontSize: "1.75rem" }}>
        <Trans i18nKey={"title"} t={t} />
      </Styled.Heading>
      <ChoiceButtons buttons={formatButtonsData(type, handleLeftChoice, handleRightChoice)} />
    </Styled.ContentWrapper>
  );
};
